import http from "@/api/request";
import { EMPLOYEE_OSS_BASE, SKU_OSS_BASE } from "@/config/apiBaseUrlConfig";

import type {
  GetOssAccessUrlParams,
  OssFileAccessVO,
  OssFileUploadVO,
  OssProductImageUploadParams,
  OssUploadParams,
} from "./type";

/**
 * 上传文件至 OSS（服务端中转阿里云）
 * @param params.file 上传文件
 * @param params.type OSS 目录类型：1图片 2合同 3身份证 4视频 5文件 6人脸
 */
export const uploadOssFile = ({ file, type }: OssUploadParams) => {
  const formData = new FormData();
  formData.append("file", file);
  return http.post<OssFileUploadVO>(`${EMPLOYEE_OSS_BASE}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    params: type !== undefined ? { type: String(type) } : undefined,
  });
};

/**
 * 上传商品图片至公共读 Bucket（chijing-common-oss）
 * 服务端中转上传，返回自定义域名永久链接，无需 access-url 换签
 * @param params.file 商品图片文件
 */
export const uploadProductImage = ({ file }: OssProductImageUploadParams) => {
  const formData = new FormData();
  formData.append("file", file);
  return http.post<OssFileUploadVO>(`${SKU_OSS_BASE}/product-image/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/**
 * 获取 OSS 文件短时签名访问 URL（私有 Bucket 预览/下载）
 * fileUrl 与 objectKey 二选一，fileUrl 优先
 * @param params.disposition inline=预览，attachment=下载
 */
export const getOssAccessUrl = (params: GetOssAccessUrlParams) => {
  return http.get<OssFileAccessVO>(`${EMPLOYEE_OSS_BASE}/access-url`, { params });
};
